import { yesNoList } from '@/constants/yesNoList';
export const formColumn = (ctx) => {
  return [
    {
      name: '工单编号',
      prop: 'workOrderNo',
      type: 'input',
    },
    {
      name: '公司',
      prop: 'workOrderCompanyName',
      type: 'input',
    },
    {
      name: '工单名称',
      prop: 'name',
      type: 'input',
    },
    {
      name: '工单类型',
      prop: 'typeStr',
      type: 'input',
    },
    {
      name: '派单部门',
      prop: 'workOrderDepartmentNo',
      type: 'select',
      options: ctx.departmentList || [],
    },
    {
      name: '工单状态',
      prop: 'workOrderStatusStr',
      type: 'input',
    },
    {
      name: '派单人',
      prop: 'dispatchPersonName',
      type: 'input',
    },
    {
      name: '派单时间',
      prop: 'dispatchTime',
      type: 'input',
    },
    {
      name: '是否关联报修单',
      prop: 'relatedRepairFlag',
      type: 'select',
      options: yesNoList,
    },
    {
      name: '报修单号',
      prop: 'repairNo',
      type: 'input',
    },
    {
      name: '接单人',
      prop: 'receivePersonName',
      type: 'input',
    },
    {
      name: '联系电话',
      prop: 'contactPhone',
      type: 'input',
    },
    {
      name: '计划完工日期',
      prop: 'planCompleteDate',
      type: 'date',
    },
    {
      name: '实施方式',
      prop: 'executeMode',
      type: 'select',
      options: ctx.setOptions.executeMode || [],
    },
    {
      name: '备注',
      prop: 'remark',
      type: 'input',
      maxlength: 50,
    },
  ];
};

export const columnListDefault = [
  {
    field: 'projectNo',
    title: '维修项目编号',
    visible: true,
  },
  {
    field: 'typeStr',
    title: '维修类型',
    visible: true,
  },
  {
    field: 'content',
    title: '维修内容',
    visible: true,
  },
  {
    field: 'completeDate',
    title: '完工日期',
    visible: true,
  },
  {
    field: 'checkPersonName',
    title: '验收人',
    visible: true,
  },
  {
    field: 'checkResult',
    title: '验收结果',
    visible: true,
  },
  {
    field: 'checkDate',
    title: '验收日期',
    visible: true,
  },
  {
    field: 'checkDesc',
    title: '验收说明',
    visible: true,
  },
];
